import { SCHEDULING_META } from 'constants/endpoints';
import { METHOD_GET } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_GET_schedulingMeta = (): ApiRequestConfigType => ({
  __typename: 'LegacyAPI',
  method: METHOD_GET,
  url: SCHEDULING_META(),
});
